const initUsernameFields = () => {
    const usernameFields = document.querySelectorAll('input[name="username"]');
    usernameFields.forEach((usernameField) => {
        usernameField.addEventListener('change', () => {
            usernameField.value = usernameField.value.trim();
        });
    });
};
export const initLogin = () => {
    document.readyState === 'loading'
        ? document.addEventListener('DOMContentLoaded', initUsernameFields)
        : initUsernameFields();
};
